import { create } from "zustand";
import type { User } from "../types/user.types";

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  setUser: (user: User | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: Boolean(localStorage.getItem("token")),
  user: null,
  setUser: (user: User | null) =>
    set({ isAuthenticated: Boolean(localStorage.getItem("token")) && Boolean(user), user }),
  logout: () =>
    set(() => {
      localStorage.removeItem("token");
      return { isAuthenticated: false, user: null };
    }),
}));